import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import { Map } from '../../../../components/Map';
import { Spots } from '../../../../components/Spots';


const MapAppLinkButton: FC<Spot> = (props) => {
    function openMapApp() {
        const a = document.createElement("a");
        a.href = `https://www.google.com/maps/search/?api=1&query=${props.lat},${props.lng}`;
        a.target = '_blank';
        a.rel = 'noopener noreferrer';
        a.click();
    };

    return (
        <button type="button" onClick={openMapApp}>
            地図アプリで見る

            <style jsx>{`
                button {
                    cursor: pointer;
                    background: #fff;
                    position: absolute;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    bottom: 20px;
                    right: 15px;
                    padding: 8px;
                    outline: none;
                    border: solid 2px #f7f7f7;
                    box-shadow: 0 0 8px gray;
                    border-radius: 4px;
                }
            `}</style>
        </button>
    );
};


export const LocationMap: FC<Spot> = (props) => {

    return (
        <>
            <div className="title">
                <div>
                    <p>{props.genre}</p>
                    <h1>{props.name}</h1>
                </div>
                {props.editable ? <Link to={{ pathname: `/map/spot/${props.id}/edit`, state: props }}>
                    <button className="edit-button">
                        <img src="/img/btn_edit.png" alt="編集ボタン" />
                    </button>
                </Link> : null}
            </div>
            <Map
                spots={[props]}
                center={{
                    lat: props.lat,
                    lng: props.lng,
                }}
                floatingActionButton={<MapAppLinkButton {...props} />}
            >
                <Spots data={[props]} />
            </Map>

            <style jsx>{`
                .title {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 54px;
                }
                .title > div > p {
                    font-size: 14px;
                    margin: auto;
                }
                h1 {
                    font-weight: normal;
                    font-size: 20px;
                    margin: 0;
                }
                .edit-button {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 36px;
                    height: 36px;
                    margin-top: 12px;
                    padding: 0;
                    border: solid 1px #ff6e01;
                    background: #fff;
                    border-radius: 50%;
                }
                .edit-button > img {
                    width: 18px;
                    height: 18px;
                }
                @media screen and (max-width: 540px) {
                    .title > div > p {
                        font-size: 12px;
                        margin: auto;
                    }
                }
            `}</style>
        </>
    );
};
